/**
 * @Author: Nenad Brcic
 * @Date: 23.05.16
 * @Email: neno@neno.ch
 */

import React, { PropTypes } from 'react';
import CSSModules from 'react-css-modules';
import Icon from '../Icon';
import Facebook from './service/Facebook';
import Twitter from './service/Twitter';
import Email from './service/Email';
import localize from '../../../localize';
import { getCurrentLanguage } from '../../../localData';
import styles from './social-share.scss';

const SocialShare = ({ title, url, onClose }) => {

    const l = (key) => {
        const str = `${getCurrentLanguage()}.components.${key}`;
        return localize(str);
    };

    return (
        <aside styleName="wrapper">
            <h2 styleName="toggle" onClick={ onClose }>
                    <span className="content-box">
                        <Icon icon="Vitra_Share.svg" styleName="icon-share" />
                        { l('Services.share') }
                        <button styleName="close">
                            <Icon icon="Vitra_Close.svg" />
                        </button>
                    </span>
            </h2>
            <ul className="nav-list">
                <li styleName="item">
                    <Facebook title={title} buttonText={ l('SocialShare.facebook.title') } url={url} />
                </li>
                <li styleName="item">
                    <Twitter title={title} buttonText={ l('SocialShare.twitter.title') } url={url} />
                </li>
                <li styleName="item">
                    <Email title={title} buttonText={ l('SocialShare.email.title') } url={url} />
                </li>
            </ul>
        </aside>
    );
};

SocialShare.propTypes = {
    title: PropTypes.string.isRequired,
    url: PropTypes.string.isRequired,
    onClose: PropTypes.func.isRequired,
};

export default CSSModules(SocialShare, styles);


// WEBPACK FOOTER //
// ./app/components/shared/SocialShare/index.jsx